<ul class="m-0 list-none p-4">
  <li>
    <div
      class="p-ripple flex cursor-pointer items-center justify-between py-2 pl-2 pr-2 text-surface-600 dark:text-surface-200"
      enterActiveClass="animate-slidedown"
      enterFromClass="hidden"
      leaveActiveClass="animate-slideup"
      leaveToClass="hidden"
      pStyleClass="@next"
    >
      <span class="text-sm font-medium uppercase text-surface-500 dark:text-surface-400">{{
        title()
      }}</span>
      <!--i class="pi pi-chevron-down text-surface-400 dark:text-surface-600"></i-->
    </div>
    <ul class="m-0 list-none overflow-hidden">
      @if (navItems()?.length === 0) {
        <div class="my-4 flex flex-col space-y-2">
          <p-skeleton height="3rem"></p-skeleton>
          <p-skeleton height="3rem"></p-skeleton>
          <p-skeleton height="3rem"></p-skeleton>
          <p-skeleton height="3rem"></p-skeleton>
        </div>
      }
      @for (item of groupedNavItems(); track item.id) {
        @if (item.children && item.children.length) {
          <li class="my-1">
            <a
              class="p-ripple flex cursor-pointer items-center p-2 text-surface-700 transition-colors duration-150 rounded-border hover:bg-surface-100 dark:text-surface-200 dark:hover:bg-surface-800"
              enterActiveClass="animate-slidedown"
              enterFromClass="hidden"
              leaveActiveClass="animate-slideup"
              leaveToClass="hidden"
              pStyleClass="@next"
            >
              @if (item.icon) {
                <span class="material-icons mr-2 text-surface-400 dark:text-surface-500">{{
                  item.icon
                }}</span>
              }
              <span class="font-medium">{{ item.name }}</span>
              <span class="material-icons ml-auto">keyboard_arrow_down</span>
            </a>
            <ul
              class="m-0 list-none overflow-y-hidden py-0 pl-4 pr-0 transition-all duration-[400ms] ease-in-out has-[.active]:block"
              [ngClass]="{ hidden: !item.expanded }"
            >
              @for (child of item.children; track child.id; let isLast = $last) {
                <li
                  class="my-1 text-surface-500 hover:text-surface-700 dark:text-surface-400"
                  [ngClass]="{ 'mb-2': isLast }"
                >
                  @if (child.url) {
                    <a
                      class="p-ripple flex cursor-pointer items-center p-2 transition-colors duration-150 rounded-border hover:bg-surface-100 dark:hover:bg-surface-800 dark:hover:text-surface-200"
                      [href]="child.url"
                      rel="nofollow"
                      target="_blank"
                    >
                      @if (child.icon) {
                        <span class="material-icons mr-2 text-surface-400 dark:text-surface-500">{{
                          child.icon
                        }}</span>
                      }
                      <span class="pl-2 font-medium">{{ child.name }}</span>
                    </a>
                  } @else {
                    <a
                      class="p-ripple flex cursor-pointer items-center p-2 transition-colors duration-150 rounded-border hover:bg-surface-100 dark:hover:bg-surface-800 dark:hover:text-surface-200"
                      [queryParamsHandling]="'preserve'"
                      [routerLink]="child.routerLink"
                      [routerLinkActive]="[
                        'bg-surface-100',
                        'text-primary-500',
                        'dark:bg-surface-800',
                        'dark:text-primary-500',
                        'active',
                      ]"
                      (click)="menuItemClicked()"
                    >
                      @if (child.icon) {
                        <span class="material-icons mr-2 text-surface-400 dark:text-surface-500">{{
                          child.icon
                        }}</span>
                      }
                      <span class="pl-2 font-medium">{{ child.name }}</span>
                    </a>
                  }
                </li>
              }
            </ul>
          </li>
        } @else {
          <li class="my-1">
            @if (item.type === 'account') {
              <span
                class="p-ripple flex cursor-pointer items-center p-2 text-surface-700 transition-colors duration-150 rounded-border hover:bg-surface-100 dark:text-surface-200 dark:hover:bg-surface-800"
                (click)="op.toggle($event)"
                (keyup.enter)="op.toggle($event)"
                tabindex="2"
              >
                @if (item.icon) {
                  <span class="material-icons mr-2 text-surface-400 dark:text-surface-600">{{
                    item.icon
                  }}</span>
                }
                <span class="font-medium">{{ item.name }}</span>
              </span>
            } @else if (item.type === 'theme') {
              <span
                class="p-ripple flex cursor-pointer items-center p-2 text-surface-700 transition-colors duration-150 rounded-border hover:bg-surface-100 dark:text-surface-200 dark:hover:bg-surface-800"
                (click)="toggleDarkMode()"
                (keyup.enter)="op.toggle($event)"
                tabindex="2"
              >
                @if (item.icon) {
                  <span class="material-icons mr-2 text-surface-400 dark:text-surface-600">{{
                    item.icon
                  }}</span>
                }
                <div class="flex w-full flex-row items-center justify-between">
                  <span class="font-medium">{{ item.name }}</span>

                  <bk-dark-mode-toggle></bk-dark-mode-toggle>
                </div>
              </span>
            } @else {
              <a
                class="p-ripple flex cursor-pointer items-center p-2 text-surface-700 transition-colors duration-150 rounded-border hover:bg-surface-100 dark:text-surface-200 dark:hover:bg-surface-800"
                [queryParamsHandling]="'preserve'"
                [routerLink]="item.routerLink"
                [routerLinkActive]="[
                  'bg-surface-100',
                  'text-primary-500',
                  'dark:bg-surface-800',
                  'dark:text-primary-500',
                ]"
                (click)="menuItemClicked()"
                pRipple
              >
                @if (item.icon) {
                  <span class="material-icons mr-2 text-surface-400 dark:text-surface-600">{{
                    item.icon
                  }}</span>
                }

                <span class="font-medium">{{ item.name }}</span>
              </a>
            }
          </li>
        }
      }
    </ul>
  </li>
</ul>
<p-popover
  (onHide)="showAccountMenu.set(false)"
  (onShow)="showAccountMenu.set(true)"
  #op
>
  <!--Account menu needs to be initiated after popover is opened to make virtual scroll work-->
  <div class="h-96 max-h-full overflow-y-auto">
    @if (showAccountMenu()) {
      <bk-account-menu></bk-account-menu>
    }
  </div>
</p-popover>
